<template>
  <p class="sns-post-loader-parts" v-text="$tc('HomePage.loading')" />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * HOME SNSコンテンツ Loader Parts
 */
export default defineComponent({
  name: 'SnsPostLoaderParts',
})
</script>

<style lang="scss" scoped>
.sns-post-loader-parts {
  padding-top: 30px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  letter-spacing: 0.02em;
  color: $gray20;
}
</style>
